import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12.424 5.576a.6.6 0 0 1 0 .848L7.448 11.4H18a.6.6 0 1 1 0 1.2H7.448l4.976 4.976a.6.6 0 0 1-.848.848l-6-6a.6.6 0 0 1 0-.848l6-6a.6.6 0 0 1 .848 0Z"
      clip-rule="evenodd"
    />
  </svg>
`;
